import { ContactState, contact } from '../containers/ContactProfile/reducer';
import { ReferenceState, references } from '../containers/CandidatePane/reducer';
import { CandidatesState, candidates } from '../containers/ReferencePane/reducer';
import { combineReducers } from 'redux';

export type ContactProfileState = {
  contact: ContactState;
  references: ReferenceState;
  candidates: CandidatesState;
};

export default combineReducers({
  contact,
  candidates,
  references
});
